import { throttle } from 'lodash-es';

/**
 * Determines wether we should display the nsfw overlay at all.
 *
 * @param {object} product can be data from algolia search or shopify gql
 * @returns {boolean}
 */
export const displayNsfwOverlay = ({ tags }) => {
  if (window.sessionStorage.getItem('nsfw')) {
    return false;
  }

  return tags.includes('nsfw');
};

const removeNsfwElements = () => {
  document.querySelectorAll('.nsfw').forEach((el) => {
    el.remove();
  });
};

/**
 * Removes every `.nsfw` container element and sets a session property
 * so the user doesn't have to click "continue anyway" for the
 * remained of the session.
 *
 * @param {MouseEvent|null} e click event
 */
export const removeNsfwOverlay = (e = null, opts = { throttle: false, writeSession: true }) => {
  if (opts.writeSession) window.sessionStorage.setItem('nsfw', 1);

  // prevents the click from going to the product page
  if (e) e.preventDefault();

  return opts.throttle ? throttle(removeNsfwElements, 100) : removeNsfwElements();
};

export default {
  displayNsfwOverlay,
  removeNsfwOverlay,
};
